// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2PlTs","errorLogs":"styles_errorLogs__VD6Lx"};